// firebase
import { db } from "config/firebase";
import { collection, doc, getDoc, setDoc } from "firebase/firestore";

// utils
import unixTimestampInSeconds from "utils/unixTimestampInSeconds";

// A ---------------------------------------------------------------------- M

const activateAPIKey = async (uuid, data) => {
  if (!data.APIKey) {
    console.error("APIKey is required in the data object.");
  }

  try {
    const userRef = doc(db, "enabled_records", uuid);
    const userDoc = await getDoc(userRef);

    if (!userDoc.exists()) {
      await setDoc(userRef, {});
    }

    const enabledAPIKeysRef = collection(userRef, "enabled_api_keys");

    const keyData = {
      ...data,
      added_on: unixTimestampInSeconds(),
    };

    await setDoc(doc(enabledAPIKeysRef, data.APIKey), keyData);

    return {
      success: true,
      APIKey: data.APIKey,
    };
  } catch (error) {
    console.error("Error in activateAPIKey:", error);

    return {
      success: false,
      message: `Error in activateAPIKey: ${error}`,
    };
  }
};

export default activateAPIKey;
